import { combineReducers } from 'redux';
import project, * as projectExports from './project';
import surveyQuestions, * as surveyQuestionsExports from './surveyQuestions';
import surveyGroups, * as surveyGroupsExports from './surveyGroups';
import surveyViewCount, * as surveyViewCountExports from './surveyViewCount';
import surveyResponses, * as surveyResponsesExports from './surveyResponses';
import questionProperty, * as questionPropertyExports from './questionProperty';
import surveyTimings, * as surveyTimingsExports from './surveyTimings';
import { MAYBE_FETCH_REQUEST } from '../../sharedActionTypes';
import {
  GET_PROJECT,
  GET_PUBLIC_PROJECT,
  GET_QUESTION_PROPERTY,
  GET_PUBLIC_QUESTION_PROPERTY,
  GET_SURVEY_GROUPS,
  GET_SURVEY_QUESTIONS,
  GET_SURVEY_RESPONSES,
  GET_PUBLIC_SURVEY_GROUPS,
  GET_PUBLIC_SURVEY_QUESTIONS,
  GET_PUBLIC_SURVEY_RESPONSES,
  RESET_SURVEY_RESPONSES,
  GET_SURVEY_TIMINGS,
  GET_PUBLIC_SURVEY_TIMINGS,
  GET_SURVEY_VIEW_COUNT,
  GET_QUALTRICS_SURVEY_QUESTIONS,
  GET_QUALTRICS_SURVEY_RESPONSES,
} from '../../fetchTypes';

const fetcherReducer = combineReducers({
  project,
  surveyQuestions,
  surveyGroups,
  surveyViewCount,
  surveyResponses,
  questionProperty,
  surveyTimings,
});

export const selectRequestStatusByAction = (state, action) => {
  if (action.type !== MAYBE_FETCH_REQUEST) {
    throw new Error(
      `selectCurrentRequestStatus called with an action other than MAYBE_FETCH_REQUEST, action = ${JSON.stringify(
        action
      )}`
    );
  }
  switch (action.fetchType) {
    case GET_PROJECT:
      return projectExports.selectProjectByProjectId(
        projectExports.actionDataToId(action.data)
      )(state);
    case GET_PUBLIC_PROJECT:
      return projectExports.selectProjectByProjectId(
        projectExports.actionDataToId(action.data)
      )(state);
    case GET_SURVEY_QUESTIONS:
      return surveyQuestionsExports.selectSurveyQuestionsByProjectId(
        surveyQuestionsExports.actionDataToId(action.data)
      )(state);
    case GET_SURVEY_GROUPS:
      return surveyGroupsExports.selectSurveyGroupsByProjectId(
        surveyGroupsExports.actionDataToId(action.data)
      )(state);
    case GET_PUBLIC_SURVEY_QUESTIONS:
      return surveyQuestionsExports.selectSurveyQuestionsByProjectId(
        surveyQuestionsExports.actionDataToId(action.data)
      )(state);
    case GET_PUBLIC_SURVEY_GROUPS:
      return surveyGroupsExports.selectSurveyGroupsByProjectId(
        surveyGroupsExports.actionDataToId(action.data)
      )(state);
    case GET_SURVEY_VIEW_COUNT:
      return surveyViewCountExports.selectSurveyViewCountBySid(
        surveyViewCountExports.actionDataToId(action.data)
      )(state);
    case GET_SURVEY_RESPONSES:
      return surveyResponsesExports.selectSurveyResponsesByProjectId(
        surveyResponsesExports.actionDataToId(action.data)
      )(state);
    case GET_PUBLIC_SURVEY_RESPONSES:
      return surveyResponsesExports.selectSurveyResponsesByProjectId(
        surveyResponsesExports.actionDataToId(action.data)
      )(state);

    case RESET_SURVEY_RESPONSES:
      return surveyResponsesExports.selectSurveyResponsesByProjectId(
        surveyResponsesExports.actionDataToId(action.data)
      )(state);

    case GET_QUESTION_PROPERTY:
      return questionPropertyExports.selectQuestionPropertyByQid(
        questionPropertyExports.actionDataToId(action.data)
      )(state);
    case GET_SURVEY_TIMINGS:
      return surveyTimingsExports.selectSurveyTimingsByProjectId(
        surveyTimingsExports.actionDataToId(action.data)
      )(state);
    case GET_PUBLIC_QUESTION_PROPERTY:
      return questionPropertyExports.selectQuestionPropertyByQid(
        questionPropertyExports.actionDataToId(action.data)
      )(state);
    case GET_PUBLIC_SURVEY_TIMINGS:
      return surveyTimingsExports.selectSurveyTimingsByProjectId(
        surveyTimingsExports.actionDataToId(action.data)
      )(state);
    case GET_QUALTRICS_SURVEY_QUESTIONS:
      return surveyQuestionsExports.selectSurveyQuestionsByProjectId(
        surveyQuestionsExports.actionDataToId(action.data)
      )(state);
    case GET_QUALTRICS_SURVEY_RESPONSES:
      return surveyResponsesExports.selectSurveyResponsesByProjectId(
        surveyResponsesExports.actionDataToId(action.data)
      )(state);
    default:
      throw new Error(
        `Unknown fetchType "${action.fetchType}" given to selectCurrentRequestStatus`
      );
  }
};

export default fetcherReducer;
